import React from 'react'
import PropTypes from 'prop-types'

function FeatureSection(props) {
  return (
    <div
      className={`relative md:flex md:flex-col md:items-center w-full max-w-xs p-4 xl:px-8 bg-brandYellow-two rounded-tr-huge mb-4 ${props.containerClass}`}
    >
      <div className="absolute w-full top-0 left-0 h-48 md:h-40 xl:h-56 rounded-tr-huge bg-brandYellow-one clip-bottom"></div>
      <div className="mb-8">
        <img
          className="relative z-10 w-full h-40 md:h-32 xl:h-48 object-contain"
          src={props.imageSrc}
          alt="online everywhere"
        />
      </div>
      <div className="mb-4">
        <h2 className="md:max-w-sm min-height-title mb-3 text-xl lg:text-2xl text-gray-700 text-center capitalize font-display">
          {props.heading}
        </h2>
        <p className="md:max-w-sm min-height-body text-gray-700 text-center font-body">
          {props.body}
        </p>
      </div>
    </div>
  )
}

FeatureSection.propTypes = {
  body: PropTypes.string.isRequired,
  heading: PropTypes.string.isRequired,
  imageOnRight: PropTypes.bool,
  imageSrc: PropTypes.string.isRequired
}

export default FeatureSection
